import Enum from '/@/modules/core/app/helpers/Enum';

export class StepState extends Enum {
  static OPTIONAL = {
    key: 'optional',
    value: 'Optional'
  };

  static MANDATORY = {
    key: 'mandatory',
    value: 'Mandatory'
  };

  static HIDDEN_BY_DEPENDENCY = {
    key: 'hidden_by_dependency',
    value: 'Hidden by dependency'
  };
}
